export default {
    remove: 'Remove'
}
